import React from 'react';
import { hRoot, passportRoot, lptRoot } from '@liepin/js-core4c-fe';
import './index.less';

const SimpleHeader: React.FC = () => {

  return (
    <>
      <header id="framework-pc-header-container">
        <nav className="header-content-box">
          <a id="header-logo-box-new" title="猎聘网">
            <img src="https://download.lietou-static.com/img/610bb5592a02d60fe2b896b202u.png" title="猎聘网" alt="" />
          </a>
          <div className="header-quick-menu-box">
            <ul className="header-quick-menu-not-login">
              <li className="header-menu-item header-quick-menu-not-login-item">
                <a
                  id="header-quick-menu-hunter"
                  target="_blank"
                  href={`${hRoot}/#sfrom=click-pc_homepage-front_navigation-hunter_new`}
                >
                  我是猎头
                </a>
              </li>
              <li className="header-menu-item header-quick-menu-not-login-item">
                <a
                  id="header-quick-menu-recruiter"
                  target="_blank"
                  href={`${passportRoot}/logout?rdurl=${lptRoot}/user/login#sfrom=click-pc_homepage-front_navigation-ecomphr_new`}
                >
                  我是招聘方
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </>
  )
}

export default SimpleHeader
